import React, { useState, useEffect, useMemo, useLayoutEffect, useRef } from "react";
import { GoogleOAuthProvider } from "@react-oauth/google";
import LoginButton from "../components/login";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { v4 as uuidv4 } from "uuid";
import { API_IP } from "../global_variables";
import { randomNumber } from "../functions/RandomNumber";
import { amityLogin } from "./Amity/AmityProvider.ts";
import toast from "react-hot-toast";
import "./Auth.css";

const LoginForm = ({ setUser, setLogin, loggedIn }) => {
  const [logindata, setLogindata] = useState({ email: "", password: "" });
  const [deviceToken, setDeviceToken] = useState("");
  const [loginOptions, setLoginOptions] = useState(false);
  const [loginMethods, setLoginMethods] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const paneRef = useRef(null);
  const [paneHeight, setPaneHeight] = useState(null);

  useMemo(() => randomNumber(), []);
  const chooseMethods = (method) => {
    console.log("Method chosen: ", method);
    setLoginOptions(true);
    setLoginMethods(method);
  };
  const goBackOptions = () => {
    setLoginOptions(false);
    setLoginMethods("");
    setEmail("");
    setPassword("");
  };
  const navigate = useNavigate();
  useEffect(() => {
    setDeviceToken(uuidv4());
  }, []);

  useLayoutEffect(() => {
    const el = paneRef.current;
    if (!el) return;
    const measure = () => {
      const next = el.scrollHeight;
      setPaneHeight(next);
    };
    measure();
    const ro = new ResizeObserver(() => measure());
    ro.observe(el);
    return () => ro.disconnect();
  }, [loginOptions, loginMethods, showPassword, isSubmitting, email, password]);

  const handleLoginButtonClick = async (e) => {
    e.preventDefault();

    const storage = rememberMe ? localStorage : sessionStorage;
    if (!email.trim() || !password.trim()) {
      toast.error("Please enter your username/email and password.");
      return;
    }
    setIsSubmitting(true);
    let newLogindata = { email: email.trim(), password: password.trim() };
    setLogindata(newLogindata);

    const loginURL = `${API_IP}/api/login/`;
    const requestBody = {
      username: email.trim(),
      password: password.trim(),
      device_token: deviceToken.trim(),
    };

    try {
      const response = await axios.post(loginURL, requestBody, {
        headers: {
          "Content-Type": "application/json",
        },
      });
      const data = response.data;

      // Store JWT token in local storage
      storage.setItem("token", data.token);
      storage.setItem("username", data.username);
      storage.setItem("userId", data.userId);
      storage.setItem("isAdmin", data.isAdmin);
      setLogin(true);
      try {
        await amityLogin("A" + data.userId, data.username);
      } catch (error) {
        console.log("Amity login failed (LoginForm):", error);
      }
      navigate("/main", {
        state: { user: { email: email, username: data.username } },
      });

      setUser({ username: data.username, userId: data.userId });

      console.log("Login successful:", data);
    } catch (error) {
      const status = error?.response?.status;
      const payload = error?.response?.data;
      const serverMsg =
        (typeof payload === "object" && payload && (payload.message || payload.error)) ||
        (typeof payload === "string" ? payload : "");

      if (status === 401 || serverMsg === "Unauthorized") {
        toast.error("Incorrect username or password.");
        setIsSubmitting(false);
        return;
      }

      if (status) {
        toast.error(`Login failed (${status}). Please try again.`);
      } else {
        toast.error("Unable to reach the server. Please try again.");
      }
      setIsSubmitting(false);
    }
    setIsSubmitting(false);
  };

  return (
    <>
      <div className="contentContainer">
        <div className="AuthShell AuthPageEnter">
          <div className="AuthCard">
            <div className="AuthLeftPane">
              <div className="AuthBrand">
                <img
                  src={require("./../images/iCareVillage_logo.webp")}
                  alt="iCareVillage"
                  className="AuthBrandLogo"
                />
                <div>
                  <div className="AuthBrandName">iCare Village</div>
                  <div className="AuthBrandTag">Care made simple, for you and your family.</div>
                </div>
              </div>
              <div className="AuthHighlights">
                <div className="AuthHighlightItem">
                  <div className="AuthDot" />
                  <div>Book care visits and manage your schedule</div>
                </div>
                <div className="AuthHighlightItem">
                  <div className="AuthDot" />
                  <div>Message care providers in one place</div>
                </div>
                <div className="AuthHighlightItem">
                  <div className="AuthDot" />
                  <div>Secure payments and saved methods</div>
                </div>
              </div>
            </div>

            <div className="AuthRightPane">
              <div className="AuthHeader">
                <h1>Sign in</h1>
                <p>Welcome back. Please choose a sign-in method.</p>
              </div>

              <div
                className="AuthPaneMotion"
                style={paneHeight ? { height: paneHeight } : undefined}
              >
                <div ref={paneRef} className="AuthPaneInner">
                  {!loginOptions ? (
                    <div className="AuthMethodGrid AuthFadeInUp" key="methods">
                  <button
                    type="button"
                    className="AuthMethodButton"
                    onClick={() => chooseMethods("icaresolution")}
                  >
                    <span className="AuthMethodIconWrap">
                      <img
                        src={require("./../images/iCareVillage_logo.webp")}
                        alt="iCareSolution"
                        className="AuthMethodIcon"
                      />
                    </span>
                    <span className="AuthMethodText">
                      <span className="AuthMethodTitle">Continue with iCareSolution</span>
                      <span className="AuthMethodSub">Use your iCareSolution credentials</span>
                    </span>
                  </button>

                  <button
                    type="button"
                    className="AuthMethodButton"
                    onClick={() => chooseMethods("gmail")}
                  >
                    <span className="AuthMethodIconWrap">
                      <img
                        src={require("./../images/google-icon.png")}
                        alt="Google"
                        className="AuthMethodIcon"
                      />
                    </span>
                    <span className="AuthMethodText">
                      <span className="AuthMethodTitle">Continue with Google</span>
                      <span className="AuthMethodSub">Sign in quickly with your Google account</span>
                    </span>
                  </button>
                </div>
                  ) : (
                    <>
                      {loginMethods === "icaresolution" ? (
                        <form className="AuthForm AuthFadeInUp" onSubmit={handleLoginButtonClick} key="form">
                      <div className="AuthField">
                        <label htmlFor="email">Email or username</label>
                        <input
                          id="email"
                          type="text"
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder="you@example.com"
                          autoComplete="username"
                        />
                      </div>

                      <div className="AuthField">
                        <label htmlFor="password">Password</label>
                        <div className="AuthInputWithAction">
                          <input
                            id="password"
                            type={showPassword ? "text" : "password"}
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            autoComplete="current-password"
                          />
                          <button
                            type="button"
                            className="AuthInputAction"
                            onClick={() => setShowPassword((v) => !v)}
                          >
                            {showPassword ? "Hide" : "Show"}
                          </button>
                        </div>
                      </div>

                      <div className="AuthRow">
                        <label className="AuthCheck">
                          <input
                            type="checkbox"
                            checked={rememberMe}
                            onChange={(e) => setRememberMe(e.target.checked)}
                          />
                          <span>Remember me</span>
                        </label>
                        <a className="AuthLink" href="/forgotpassword">
                          Forgot password?
                        </a>
                      </div>

                      <button
                        type="submit"
                        className="AuthPrimaryButton"
                        disabled={isSubmitting}
                      >
                        {isSubmitting ? "Signing in..." : "Sign in"}
                      </button>

                      <button
                        type="button"
                        className="AuthSecondaryButton"
                        onClick={goBackOptions}
                        disabled={isSubmitting}
                      >
                        Back
                      </button>
                    </form>
                      ) : (
                        loginMethods === "gmail" && (
                          <div className="AuthOAuth AuthFadeInUp" key="google">
                        <div className="AuthOAuthBox">
                          <div className="AuthOAuthTitle">Continue with Google</div>
                          <div className="AuthOAuthSub">
                            We’ll redirect you to Google to securely sign in.
                          </div>
                          <div className="AuthOAuthButtonWrap">
                            <GoogleOAuthProvider clientId="168590105791-87i5ulsl54rogj7v9a5h4vki2tifv7kt.apps.googleusercontent.com">
                              <LoginButton setLogin={setLogin} setUser={setUser} />
                            </GoogleOAuthProvider>
                          </div>
                        </div>
                        <button
                          type="button"
                          className="AuthSecondaryButton"
                          onClick={goBackOptions}
                        >
                          Back
                        </button>
                      </div>
                        )
                      )}
                    </>
                  )}
                </div>
              </div>

              <div className="AuthFooter">
                <div className="AuthDivider">
                  <span>or</span>
                </div>
                <div className="AuthFooterRow">
                  <span>New to iCareVillage?</span>
                  <a className="AuthLink" href="/register/">
                    Create an account
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default LoginForm;
